/**
 * <facet-filters> — native Shopify filtering, submitted via the Section
 * Rendering API instead of a full page reload. Simplification vs. Dawn:
 * Dawn splits the collection page into a facets section and a separate
 * product-grid section for a narrower partial refresh; here both live in
 * one `main-collection` section and get replaced together (documented in
 * docs/THEME_ARCHITECTURE.md) — one fewer moving part, same no-reload UX.
 */
class FacetFilters extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
  }

  connectedCallback() {
    this.form.addEventListener('input', window.NantesUtils.debounce(this.onChange.bind(this), 400));
    this.form.addEventListener('change', (event) => {
      if (event.target.tagName === 'SELECT') this.onChange();
    });

    const toggle = document.querySelector('[data-facets-toggle]');
    const panel = document.querySelector('#facets-panel');
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const isOpen = !panel.hidden;
        panel.hidden = isOpen;
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
      document.addEventListener('click', (event) => {
        if (panel.hidden) return;
        if (this.contains(event.target)) return;
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  onChange() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams(formData).toString();
    this.updateResults(params);
  }

  async updateResults(params) {
    const url = `${window.location.pathname}?${params}`;
    const grid = document.querySelector('[data-main-collection-grid]');
    grid && grid.classList.add('is-loading');

    try {
      const response = await fetch(`${url}&section_id=main-collection`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[data-main-collection-grid]');
      if (grid && newGrid) grid.replaceWith(newGrid);

      const newFacets = doc.querySelector('facet-filters');
      const currentFacets = document.querySelector('facet-filters');
      if (currentFacets && newFacets) currentFacets.replaceWith(newFacets);

      history.pushState({}, '', url);
    } catch (error) {
      grid && grid.classList.remove('is-loading');
    }
  }
}

customElements.define('facet-filters', FacetFilters);
